import { DoodMarketplaceModel, IBlockConfig } from '@core/models/marketplace.model';

/** Stable backing-block id for a platform modal injected into the CB2 preview. */
export function cb2DefaultModalBlockId(handle: string): string {
  return `cb2-default-modal-${handle}`;
}

/**
 * `injectDefaultModals` assigns a new lodash `uniqueId()` on every preview apply.
 * The modals container keeps the previous block id, so the open modal unmounts
 * as soon as a bloc prop (title, color, …) is edited. Injected modals keep a
 * stable id; journey-defined modals are left untouched.
 */
export function stabilizeInjectedPreviewModalBlockIds(
  marketplace: DoodMarketplaceModel,
  journeyModalHandles: ReadonlySet<string>,
): DoodMarketplaceModel {
  const blocks = [...(marketplace.blocks ?? [])] as IBlockConfig[];
  const modals = (marketplace.modals ?? []).map(modal => {
    if (!modal.handle || journeyModalHandles.has(modal.handle)) {
      return modal;
    }

    const stableId = cb2DefaultModalBlockId(modal.handle);
    const blockIndex = blocks.findIndex(block => block.id === modal.block);
    if (blockIndex >= 0 && blocks[blockIndex].id !== stableId) {
      blocks[blockIndex] = { ...blocks[blockIndex], id: stableId };
    }

    return modal.block === stableId ? modal : { ...modal, block: stableId };
  });

  return { ...marketplace, modals, blocks };
}
